<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-center py-0 my-10">
        <!--begin::Title-->
        <h2 class="fs-1x fw-bolder">
          {{
            listState === "active" ? "RESTRICCIONES ACTIVAS" : "RESTRICCIONES LEVANTADAS"
          }}
          <i
            :class="
              listState === 'active'
                ? 'fas fa-circle text-success'
                : 'fas fa-circle text-primary'
            "
          ></i>
        </h2>
        <h3
          class="p-6"
          v-if="rol !== 'supervisor' && rol !== 'consultas departamentales'"
        >
          <!-- {{
            nombre_recinto_penitenciario === "TODOS"
              ? ""
              : "CENTRO PENITENCIARIO: "
          }} -->
          {{
            nombre_recinto_penitenciario === "TODOS"
              ? "TODOS LOS RECINTOS PENITENCIARIOS"
              : `CENTRO PENITENCIARIO:${nombre_recinto_penitenciario}`
          }}
          -
          {{
            departamento_centro_penitenciario === "NACIONAL"
              ? "NIVEL NACIONAL"
              : departamento_centro_penitenciario
          }}
        </h3>
        <h3
          class="p-10"
          v-else-if="
            rol === 'supervisor' || rol === 'consultas departamentales'
          "
        >
          SUPERVISIÓN: {{ departamento_supervisar }}
        </h3>
        <p class="text-gray-600 fs-6 fw-bold mb-0">
          <span>
            Información actualizada a : {{ currentDate }}
            <i
              title="Presione para actualizar la tabla"
              class="fas fa-refresh"
              style="font-size: 1.5em; color: teal"
              @click="restrictionList(listState === 'active' ? 'active' : 'inactive')"
            ></i
          ></span>
        </p>
        <div class="card-header border-0 pt-6">
          <button
            :class="
              listState === 'active' ? 'btn btn-primary' : 'btn btn-success'
            "
            @click="restrictionList(listState === 'active' ? 'inactive' : 'active')"
          >
            <i
              :class="
                listState === 'active' ?  'fas fa-lock-open' : 'fas fa-lock' 
              "
            ></i
            >{{
              listState === "active" ? "Restricciones Levantadas" : "Restricciones Activas"
            }}
          </button>
        </div>
        <!-- tabla de datos -->
        <div class="card-body pt-0 dropright">
          <DxDataGrid
            id="gridContainer"
            :data-source="listaRestricciones"
            key-expr="id_restriccion"
            :allow-column-reordering="false"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :show-borders="true"
            @exporting="onExporting"
          >
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="pageSizes"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="50" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />
            <!-- <DxExport :enabled="true" :allow-export-selected-data="true" /> -->
            <DxExport
              v-if="listaRestricciones.length > 0"
              :enabled="true"
              :formats="['pdf']"
              >Exportar</DxExport
            >
            <!-- <DxSelection mode="multiple" show-check-boxes-mode="always" /> -->
            <DxColumn
              :width="60"
              :allow-sorting="false"
              :allow-exporting="true"
            />
            <DxColumn
              :width="450"
              :allow-sorting="false"
              :allow-exporting="false"
              caption="Acciones"
              cell-template="cellTemplate"
            />
            <template #cellTemplate="{ data }">
            <!-- cargar archivo restriccion -->
            <button_add_files
              v-if="!data.data.documento_restriccion && listState==='active'"
              :id="Number(data.data.id_restriccion)"
              :state="'active'"
              @upload-file="handleFileUpload"
            ></button_add_files>
             <!-- ver archivo restriccion -->
              <span
                v-if="data.data.documento_restriccion"
                type="button"
                style="margin-right:10px"
                class="badge badge-info"
                title="Ver memorándum restricción pdf"
                @click="verArchivo(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-eye m-1"
                ></i>
              </span>
              <!-- eliminar archivo restriccion -->
              <span
                v-if="data.data.documento_restriccion &&
               (rol === 'admin' || rol === 'editor')"
                type="button"
                style="margin-right:10px ; background-color: #ff6347; color: #fff;"
                class="badge badge-dark"
                title="Eliminar memorándum de restricción pdf"
                @click="eliminarArchivo(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-file-circle-xmark m-1"
                ></i>
              </span>
              <!-- cargar archivo levantamiento restriccion -->
              <button_add_files
                v-if="!data.data.documento_levantamiento_restriccion && listState==='inactive'"
                :id="Number(data.data.id_restriccion)"
                :state="'inactive'"
                @upload-file="handleFileUploadLiftRestriction"
              ></button_add_files>
              <!-- ver archivo levantamiento restriccion -->
              <span
                v-if="data.data.documento_levantamiento_restriccion"
                type="button"
                style="margin-right:10px"
                class="badge badge-info"
                title="Ver memorándum levantamiento restricción pdf"
                @click="verArchivoLevantamientoRestriccion(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-eye m-1"
                ></i>
              </span>
              <!-- eliminar archivo levantamiento restriccion -->
              <span
                v-if="data.data.documento_levantamiento_restriccion &&
               (rol === 'admin' || rol === 'editor')"
                type="button"
                style="margin-right:10px ; background-color: #ff6347; color: #fff;"
                class="badge badge-dark"
                title="Eliminar memorándumd de levantamiento de restricción pdf"
                @click="eliminarArchivoLevantamientoRestriccion(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-file-circle-xmark m-1"
                ></i>
              </span>
              <!-- levantar restriccion -->
              <span
              v-if="data.data.documento_restriccion && listState==='active' "
                type="button"
                style="margin-right:10px"
                class="badge badge-primary"
                title="Levantar Restricción"
                @click="levantarRestriccion(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-person-circle-check m-1"
                ></i>
              </span>
              <!-- editar_restricción -->
              <span 
                v-if="listState==='active' && (rol === 'admin' || rol === 'editor')"
                type='button'
                style="margin-right:10px"
                class="badge badge-warning"
                title="Editar restricción"
                @click="editarRestriccion(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-edit m-1"
                ></i>
              </span>
              <!-- eliminar restricción -->
              <span 
                v-if="listState==='active' && (rol === 'admin' || rol === 'editor')"
                type='button'
                style="margin-right:10px"
                class="badge badge-danger"
                title="Eliminar restricción"
                @click="eliminarRestriccion(data.data.id_restriccion)"
              >
                <i
                  style="font-size: 1.7em; color: white"
                  class="fas fa-trash m-1"
                ></i>
              </span> 
              <!-- es indefinido -->
              <span
                v-if="data.data.es_indefinido"
                style="margin-right:10px ; background-color: #6fcce7; "
                class="badge badge-danger"
                >INDEFINIDO</span
              >
            </template>
            <!-- nombre visitante restrigido -->
            <DxColumn
              :width="295"
              data-field="nombre_visita"
              caption="Nombre Visitante Restringido"
            />
            <!-- número Documento -->
            <DxColumn
              :width="120"
              data-field="nro_doc_visita"
              caption="N° Documento"
              :allow-exporting="false"
            />
            <!-- nombre ppl -->
            <DxColumn
              :width="230"
              data-field="nombre_ppl"
              caption="Nombre PPL"
            />
            <!-- número documento ppl -->
            <DxColumn
              :width="120"
              data-field="nro_doc_ppl"
              caption="N° Documento"
              :allow-exporting="false"
            />
            <!-- fecha_inicio_restriccion -->
            <DxColumn
              :width="170"
              data-field="fecha_inicio_restriccion"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha Inicio Restricción"
            />
            <!-- dias restriccion -->
            <DxColumn
              :width="140"
              data-field="cantidad_dias_restriccion"
              caption="N° Días Restricción"
              :allow-exporting="false"
            />
            <!-- fecha_final_restriccion -->
            <DxColumn
              :width="170"
              data-field="fecha_final_restriccion"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha Final Restricción"
            />
            <!-- memorandum restricción -->
            <DxColumn
              :width="180"
              data-field="cite_restriccion"
              caption="Memorándum Restricción"
            />
            <!-- recinto Penitenciario -->
            <DxColumn
              :width="200"
              data-field="nombre_recinto_penitenciario"
              caption="Recinto Penitenciario"
            />
            <!-- tipo restricción -->
            <DxColumn
              :width="120"
              data-field="es_indefinido_literal"
              caption="Tipo Restricción"
              :allow-exporting="false"
            />

            <DxGroupPanel :visible="true" />
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <DxSummary>
              <DxGroupItem
                column="id_restriccion"
                summary-type="count"
                display-format="{0} Restricciones"
              />
              <DxTotalItem
                column="nombre_visita"
                summary-type="count"
                display-format="Total restricciones: {0}"
              />
            </DxSummary>
            <DxSortByGroupSummaryInfo summary-item="primer_apellido" />
          </DxDataGrid>
        </div>
      </div>
    </div>
  </div>
  <!-- loader -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
  <lift_restriction ref="modal" @reload-table="restrictionList"></lift_restriction>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import visits from "@/visits/composables/useVisits";
import useAuth from "@/auth/composables/useAuth";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import { useRoute, useRouter } from "vue-router";
import date from "date-and-time";
import es from "date-and-time/locale/es";
date.locale(es);
import formatDate from "@/helpers/formatDate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { exportDataGrid } from "devextreme/pdf_exporter";
import img from "../../../public/media/logos/ed002-regpen.png";
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  //DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";
import lift_restriction from "./lift_restriction_modal.vue";
import button_add_files from "../buttons/buttonAddFiles.vue";
export default defineComponent({
  name: "restrictions-list",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    DxExport,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,
    DxHeaderFilter,
    Loading,
    lift_restriction,
    button_add_files
  },
  setup() {
    const router = useRouter();
    loadMessages(esMessages);
    locale(navigator.language);
    let currentDate = ref(
      date.format(new Date(), "dddd, DD MMMM YYYY HH:mm:ss")
    );
    const isAdmin = ref(false);
    const isEditor = ref(false);
    const pageSizes = ref([10, 25, 50, 100]);
    let isLoading = ref(false);
    const listaRestricciones = ref([]);
    const listState = ref("");
    const file = ref(null);
    const dialog = ref(false);
    const modal = ref(null);
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });
    const { restrictionsList, 
            uploadFile, 
            uploadFileLiftRestriction, 
            viewFile, 
            viewFileLiftRestriction, 
            deleteFile,
            deleteFileLiftRestriction,
            deleteRestriction
          } = visits();
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    const onExporting = async (e) => {
      const doc = new jsPDF("l", "pt", "letter");
      const lastPoint = { x: 0, y: 0 };
      doc.setFontSize(0.1);
      exportDataGrid({
        jsPDFDocument: doc,
        component: e.component,
        indent: 5,
        topLeft: { x: 1, y: 70 },
        customDrawCell: function ({ rect }) {
          if (lastPoint.x < rect.x + rect.w) {
            lastPoint.x = rect.x + rect.w;
          }
          if (lastPoint.y < rect.y + rect.h) {
            lastPoint.y = rect.y + rect.h;
          }
        },
        customizeCell: function (options) {
          const { gridCell, pdfCell } = options;
          if (gridCell.rowType === "data") {
            pdfCell.font = { size: 6 };
          } else if (gridCell.rowType === "header") {
            pdfCell.backgroundColor = "#BEDFE6";
            pdfCell.font = { size: 8 };
          }
        },
      }).then(() => {
        // doc.addImage(img, 50, 20);
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageSize = doc.internal.pageSize;
          const pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
          if (pageCurrent === 1) {
            // Header
            doc.addImage(img, 50, 20);
            const header = `Restricciones - Sistema Estado Digital ED-4 Régimen Penitenciario   \n ${
              nombre_recinto_penitenciario.value === "TODOS"
                ? "TODOS LOS RECINTOS PENITENCIARIOS"
                : `CENTRO PENITENCIARIO:${nombre_recinto_penitenciario.value}`
            } - ${
              departamento_centro_penitenciario.value === "NACIONAL"
                ? "NIVEL NACIONAL"
                : `DEPARTAMENTO:${departamento_centro_penitenciario.value}`
            }\n ${currentDate.value}`;
            doc.setFont("Helvetica");
            doc.setFontSize(15);
            doc.text(header, 450, 55, {
              baseline: "top",
              align: "center",
            });
          }
          const footer = `Información extraida del Módulo de Visitas del SISTEMA ESTADO DIGITAL ED-4 RÉGIMEN PENITENCIARIO`;
          // Footer
          doc.setFontSize(9);
          doc.setTextColor("#cccccc");
          doc.text(
            footer,
            pageWidth / 1 - doc.getTextWidth(footer) / 1.5,

            pageHeight - 5,
            { baseline: "bottom", align: "right" }
          );

          //pagination
          const pagination = `Página ${i} de ${pageCount}`;
          doc.setFontSize(12);
          doc.text(
            pagination,
            pageWidth / 1 - doc.getTextWidth(pagination) / 0.8,

            pageHeight - 5,
            { baseline: "bottom", align: "left" }
          );
        }
        doc.save("reporte_restricciones_ED4.pdf");
      });
    };
    const formatDateAndHours = (date) => {
      if (date === null) {
        return "-.-";
      } else {
        const formattedDate = formatDate(date);
        return formattedDate;
      }
    };
    const restrictionList = async (state = "active") => {
      state === "active"
        ? (listState.value = "active")
        : (listState.value = "inactive");
      isLoading.value = true;
      const { data } = await restrictionsList(state);
      if (data.ok) {
        listaRestricciones.value = data.respuesta;
        isLoading.value = false;
      } else {
        alert("ERROR");
      }
      currentDate.value = date.format(
        new Date(),
        "dddd, DD MMMM YYYY HH:mm:ss"
      );
    };
    const handleFileUpload = async (val) => {
      const{file, id}=val;
      const { data } = await uploadFile([
        file,
        id,
      ]);
      if (data.ok) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf de la restricción fue registrado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        await restrictionList();
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const handleFileUploadLiftRestriction = async (val) => {
      const{file, id}=val;
      const { data } = await uploadFileLiftRestriction([
        file,
        id,
      ]);
      if (data.ok) {
        Swal.fire({
          title: "Archivo cargado correctamente",
          text: "El archivo pdf del levantamiento de restricción fue registrado exitosamente.",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
        await restrictionList('inactive');
      } else {
        Swal.fire({
          title: "Error",
          text: "El archivo no pudo ser cargado.",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Continuar",
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      }
    };
    const verArchivo = async (id) => {
      await viewFile(id);
    };
    const verArchivoLevantamientoRestriccion = async (id) => {
      await viewFileLiftRestriction(id);
    };
    const eliminarArchivo = async (id) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF de la restricción?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFile(id);
          if (data.ok) {
            Swal.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            await restrictionList();
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const eliminarArchivoLevantamientoRestriccion = async (id) => {
      Swal.fire({
        title: `¿Está seguro de eliminar el archivo PDF del levantamiento de restricción?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteFileLiftRestriction(id);
          if (data.ok) {
            Swal.fire(
              "¡Eliminado!",
              "El archivo fue eliminado satisfactoriamente.",
              "success"
            );
            await restrictionList();
          } else {
            Swal.fire({
              title: "Error",
              text: "El archivo no pudo ser eliminado.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    };
    const levantarRestriccion = async (id) =>{
      dialog.value = true;
      modal.value.showModal(
        dialog.value,
        id,
      );
    };
    const editarRestriccion = async (id) => {
      router.push({
        name: "register_restriction",
        params: {
          id
        },
      });
    }
    const eliminarRestriccion = async (id) => {
      Swal.fire({
        title: `¿Está seguro de eliminar la restricción?`,
        text: "No podrá revertir esta acción.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, eliminar",
        cancelButtonText: `Cancelar`,
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await deleteRestriction(id);
          if (data.ok) {
            Swal.fire(
              "¡Eliminado!",
              `${data.message}`,
              "success"
            );
            await restrictionList();
          } else {
            Swal.fire({
              title: "Error",
              text: "La restricción no pudo ser eliminada.",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Continuar",
              customClass: {
                confirmButton: "btn fw-bold btn-light-primary",
              },
            });
          }
        }
      });
    }
    onMounted(() => {
      setCurrentPageBreadcrumbs("Lista de restricciones de visitas a privados de libertad", [
        "Listas",
      ]);
      restrictionList();
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        } else if (rol.toUpperCase() === "EDITOR") {
          isEditor.value = true;
        }
      }
    });
    // watch(
    //   () => route.params.state,
    //   async (newState) => {
    //     console.log(newState);
    //     if (newState !== "active") {
    //       listState.value = "inactive";
    //     } else {
    //       listState.value = "active";
    //     }
    //     await visitList(newState);
    //   }
    // );
    return {
      isAdmin,
      isEditor,
      isLoading,
      listaRestricciones,
      pageSizes,
      formatDateAndHours,
      currentDate,
      restrictionList,
      listState,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
      modal,
      dialog,
      onExporting,
      // cargarDocumento,
      handleFileUpload,
      handleFileUploadLiftRestriction,
      file,
      verArchivo,
      verArchivoLevantamientoRestriccion,
      eliminarArchivo,
      eliminarArchivoLevantamientoRestriccion,
      levantarRestriccion,
      editarRestriccion,
      eliminarRestriccion
    };
  },
});
</script>
<style>
 .dx-datagrid{  
  font:11px verdana;  
} 
</style>
